export enum CORP_DEUNGI_FILTER_STATE {
    ALL = "전체",
    ACTIVE = "살아있는",
    INACTIVE = "폐쇄",
}

export enum CORP_DEUNGI_POPUP_TYPE {
    ERROR = -1,
    OPEN,
    HAS_DEUNGI,
    INFO,
}

// 1: 대기중 2: 주소검색 중 3: 주소검색 실패 4: 결제진행 중 5: 결제실패 6: PDF발급 중 7: PDF발급 실패 8: 완료 9: 에러(발급불가능한 경우)
export enum CORP_DEUNGI_OPEN_STATE {
    WAITING = 1,
    SEARCHING = 2,
    SEARCHING_FAIL,
    PAYMENT_ING,
    PAYMENT_FAIL,
    UPLOAD_ING,
    UPLOAD_FAIL,
    UPLOAD_DONE,
    ERROR,
}
